import React from 'react';
export function CTAButton({
  children,
  onClick,
  href = 'https://clearguardnutrition.com/cart/48949171650812:1,49010547556604:1,49010547392764:1,49010539364604:1,49010536907004:1'
}: {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
}) {
  const handleClick = () => {
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    if (onClick) onClick();
  };
  return <a href={href} onClick={handleClick} target="_blank" rel="noopener noreferrer" className="w-full max-w-md mx-auto block bg-brand-green hover:bg-brand-greenHover text-white font-bold py-5 px-8 rounded text-xl text-center cursor-pointer no-underline" data-id="element-580">
      {children}
    </a>;
}
export function ImagePlaceholder({
  text,
  height = 'h-64'
}: {
  text: string;
  height?: string;
}) {
  return <div className={`w-full bg-gray-200 border border-gray-300 flex items-center justify-center my-8 ${height}`} data-id="element-581">
      <span className="text-gray-500 font-semibold text-center px-4" data-id="element-582">
        {text}
      </span>
    </div>;
}
export function Divider() {
  return <hr className="my-12 border-t-2 border-gray-200" data-id="element-583" />;
}
export function SectionTitle({
  children
}: {
  children: React.ReactNode;
}) {
  return <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mt-12 mb-6 leading-tight" data-id="element-584">
      {children}
    </h2>;
}
export function Paragraph({
  children,
  bold = false
}: {
  children: React.ReactNode;
  bold?: boolean;
}) {
  return <p className={`mb-6 ${bold ? 'font-bold text-gray-900' : 'text-gray-800'}`} data-id="element-585">
      {children}
    </p>;
}